/**
 * D6ForceExtraFieldType - Type d'extraField pour la Force D6
 * Identique à PlayerForceExtraField.java
 */

import {ExtraFieldType} from '../../types/ExtraFieldType';
import {GameDataExtraField} from '../../../models/GameDataExtraField';
import {GameState} from '../../../models/GameState';
import {getValueDice} from '../util/DiceUtil';

export class D6ForceExtraFieldType implements ExtraFieldType {
  typeName = 'D6_FORCE';
  defaultValue = '1D+6';

  process(field: GameDataExtraField, gameState: GameState): void {
    // Pas de traitement spécial nécessaire
  }

  /**
   * Génère une valeur à partir d'une expression D6
   * Utilise DiceUtil.getValueDice() comme en Java
   * 
   * @param fieldValue Expression D6 (ex: "1D+6", "2D", "1")
   * @returns Valeur générée (ex: "7", "12", "1")
   */
  generateValue(fieldValue: string): string {
    return getValueDice(fieldValue).toString();
  }
}
